import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LTRIcon, RTLIcon } from 'wix-rich-content-plugin-commons';
import { LabeledToggle, SettingsSeparator, SelectionList, Label, SelectionListItem } from 'wix-rich-content-ui-components';
import cls from 'classnames';
import { L as LAYOUTS, b as DIRECTION } from '../../../helpers-d59c72d9.js';
import { s as styleInject } from '../../../style-inject.es-746bb8ed.js';
import { LayoutListIcon } from '../../../assets/icons/LayoutListIcon.js';
import { LayoutGridIcon } from '../../../assets/icons/LayoutGridIcon.js';
import 'wix-rich-content-common/libs/imageUtils';

var css_248z = "[dir=ltr] ._5yqyK{text-align:left}[dir=rtl] ._5yqyK{text-align:right}[dir] .Cst38{border-bottom:1px solid #ededed;padding:0 20px}.Cst38 .qzu7c{font-size:20px;line-height:1.4}[dir] .Cst38 .qzu7c{margin:25px 0 20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Cst38{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .Cst38{padding:20px}}}@container (width < 640px){.Cst38{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .Cst38{padding:20px}}.ee0hQ{height:auto;overflow:hidden}.Bb-mq,.ee0hQ{align-items:center;display:flex}.Bb-mq{flex-direction:row;font-family:inherit;font-size:16px;line-height:1;outline:none}[dir] .Bb-mq{background:none;border:0;padding:0}.Bb-mq.cIl3I{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.Bb-mq.sWQZE{color:inherit}._20hgl{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] ._20hgl{padding:24px}._20hgl *,._20hgl :after,._20hgl :before{box-sizing:inherit}._20hgl input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){._20hgl{height:calc(100% - 100px);top:100px}[dir] ._20hgl{padding:20px}}}@container (width < 640px){._20hgl{height:calc(100% - 100px);top:100px}[dir] ._20hgl{padding:20px}}.qzu7c{color:var(--ricos-settings-text-color,#000);font-size:16px;line-height:1.5}[dir] .qzu7c{margin:0 0 15px}.sBXkI{color:var(--ricos-settings-text-color,#000);font-size:14px;line-height:1.43}[dir] .sBXkI{margin:0 0 5px}.TDxKF,.W6UtE,._9ZE2i{font-size:14px;line-height:1.43}[dir] .TDxKF,[dir] .W6UtE,[dir] ._9ZE2i{margin:0 0 5px}[dir] .W6UtE{margin:10px 0}._75XE0{grid-column-gap:10px;grid-template-columns:repeat(3,1fr)}[dir] ._75XE0{margin:10px 0}.wuiBE{grid-column-gap:10px;grid-auto-rows:1fr;grid-template-columns:repeat(4,1fr)}[dir] .wuiBE{margin:20px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.wuiBE{grid-template-columns:repeat(3,1fr)}}}@container (width < 640px){.wuiBE{grid-template-columns:repeat(3,1fr)}}.yTROO{align-items:center;display:flex;flex-direction:row;gap:5px}[dir] .yTROO{margin:5px 0}.yTROO.cDlVm{align-items:start;display:flex;flex-direction:column}[dir] .yTROO.cDlVm{margin:10px 0 20px}.nh8fy{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:auto}[dir] .nh8fy{margin:0;padding-top:10px}[dir] .RM23W{margin:5px 0}[dir] .nh8fy:hover:not(.Oxpkf){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] .Oxpkf{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.Oxpkf *{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .GBewz{cursor:pointer;margin:15px 0;padding:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .GBewz{padding-top:0!important}}}@container (width < 640px){[dir] .GBewz{padding-top:0!important}}.Pak93{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;justify-content:center;width:80%}[dir] .Pak93{background:transparent}._82hLA{align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;position:fixed;top:0;z-index:8}[dir] ._82hLA{background-color:rgba(0,0,0,.6);cursor:auto}[dir=ltr] ._82hLA,[dir=rtl] ._82hLA{left:0;right:0}.y-nF-{display:flex;justify-content:flex-end;width:100%}[dir=ltr] .y-nF-{border-right:1px solid #ededed;padding-right:15px}[dir=rtl] .y-nF-{border-left:1px solid #ededed;padding-left:15px}.O0QqH{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] .O0QqH{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.O0QqH{max-width:100%;top:50px}}}@container (width < 640px){.O0QqH{max-width:100%;top:50px}}";
var styles = {"settings_container":"_5yqyK","header":"Cst38","title":"qzu7c","header_button_list":"ee0hQ","poll_header_button":"Bb-mq","poll_header_button_primary":"cIl3I","poll_header_button_secondary":"sWQZE","section":"_20hgl","subtitle":"sBXkI","sliderWithInput_label":"W6UtE","label":"_9ZE2i","checkbox_label":"TDxKF","preset_selector":"_75XE0","layout_selector":"wuiBE","radioGroup":"yTROO","radioPanel":"cDlVm","selectionListOption":"nh8fy","selectionListOptionLabel":"RM23W","selectionListOption_selected":"Oxpkf","labeled_toggle_root":"GBewz","modal":"Pak93","overlay":"_82hLA","preview_button":"y-nF-","poll_tab_headers":"O0QqH"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class LayoutSettingsSection extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "handlePollTypeChange", (type) => {
      const {
        componentData: { layout }
      } = this.props;
      this.updateSettings({
        poll: __spreadProps(__spreadValues({}, layout.poll), { type }),
        option: __spreadProps(__spreadValues({}, layout.options), { enableImage: type === LAYOUTS.GRID })
      });
      window.dispatchEvent(new Event("resize"));
    });
    __publicField(this, "handleDirectionChange", (direction) => {
      const {
        componentData: { layout }
      } = this.props;
      this.updateSettings({
        poll: __spreadProps(__spreadValues({}, layout.poll), { direction })
      });
    });
    __publicField(this, "renderOption", ({ item, selected }) => /* @__PURE__ */ React.createElement(SelectionListItem, { icon: /* @__PURE__ */ React.createElement(item.icon, null), selected, label: item.label }));
  }
  updateSettings(layout) {
    const { updateData, componentData } = this.props;
    updateData({ layout: __spreadValues(__spreadValues({}, componentData.layout), layout) });
  }
  render() {
    const { componentData, t, isMobile } = this.props;
    const { poll, options } = componentData.layout;
    return /* @__PURE__ */ React.createElement("section", { className: styles.section }, !isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { className: cls(styles.title) }, t("Poll_PollSettings_Tab_Layout_Section_Question_Header")), /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Layout_Section_Question_Image"),
        checked: poll == null ? void 0 : poll.enableImage,
        onChange: () => this.updateSettings({ poll: __spreadProps(__spreadValues({}, poll), { enableImage: !(poll == null ? void 0 : poll.enableImage) }) }),
        style: { paddingTop: 20 }
      }
    ), /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true, bottom: true })), /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_PollSettings_Tab_Layout_Section_Answers_Header")), /* @__PURE__ */ React.createElement("p", { className: styles.subtitle }, t("Poll_PollSettings_Tab_Layout_Section_Answers_Layout")), /* @__PURE__ */ React.createElement(
      SelectionList,
      {
        dataSource: [
          {
            value: LAYOUTS.LIST,
            label: t("Poll_PollSettings_Tab_Layout_Section_Answers_Layout_List"),
            icon: LayoutListIcon
          },
          {
            value: LAYOUTS.GRID,
            label: t("Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid"),
            icon: LayoutGridIcon
          }
        ],
        renderItem: this.renderOption,
        value: poll == null ? void 0 : poll.type,
        onChange: this.handlePollTypeChange,
        className: styles.layout_selector
      }
    ), !isMobile && /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Layout_Section_Answers_Image"),
        checked: options == null ? void 0 : options.enableImage,
        onChange: () => this.updateSettings({ options: __spreadProps(__spreadValues({}, options), { enableImage: !(options == null ? void 0 : options.enableImage) }) }),
        style: { paddingTop: 20 }
      }
    ), /* @__PURE__ */ React.createElement(SettingsSeparator, { top: true, bottom: true }), /* @__PURE__ */ React.createElement(
      Label,
      {
        label: t("Poll_PollSettings_Tab_Layout_Section_TextDirection_Header"),
        tooltipText: t("Poll_PollSettings_Tab_Layout_Section_TextDirection_Header_Tooltip"),
        isMobile,
        style: { fontSize: "16px" }
      }
    ), /* @__PURE__ */ React.createElement(
      SelectionList,
      {
        dataSource: [
          {
            value: DIRECTION.LTR.toUpperCase(),
            label: t("Poll_PollSettings_Tab_Layout_Section_TextDirection_LTR"),
            icon: LTRIcon
          },
          {
            value: DIRECTION.RTL.toUpperCase(),
            label: t("Poll_PollSettings_Tab_Layout_Section_TextDirection_RTL"),
            icon: RTLIcon
          }
        ],
        renderItem: this.renderOption,
        value: poll == null ? void 0 : poll.direction,
        onChange: this.handleDirectionChange,
        className: styles.layout_selector
      }
    ));
  }
}
LayoutSettingsSection.propTypes = {
  t: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  componentData: PropTypes.object.isRequired,
  experiments: PropTypes.object,
  updateData: PropTypes.func.isRequired
};

export { LayoutSettingsSection };
//# sourceMappingURL=LayoutSettingsSection.js.map
